const isBlankKey = (keyPress: any) => {
  return keyPress.trim() === ''
}

const lettersOnly = (keyPress: any) => {
  if (isBlankKey(keyPress)) return true
  else return Number.isNaN(Number(keyPress))
}

export const numericOnly = (keyPress: any) => {
  return !lettersOnly(keyPress)
}
